<template>
	<div
		class="chat__contact flex items-center px-2 pt-4 pb-2"
		:class="{
			'bg-primary-gradient text-white shadow-lg': resource.id === currentResourceId,
		}"
	>
		<div class="contact__avatar mr-1">
			<vs-avatar class="border-2 border-solid border-white" :src="photoURL" size="42px" />
		</div>
		<div class="contact__container w-full flex items-center justify-between overflow-hidden">
			<div class="contact__info flex flex-col truncate w-5/6">
				<h5 class="font-semibold" :class="{'text-white': resource.id === currentResourceId}">
					{{ resource.name }} {{ resource.lastname }}
				</h5>
				<span class="truncate">{{ resource.email }}</span>
			</div>

			<div class="chat__contact__meta flex self-start flex-col items-end w-1/6" v-if="total > 0">
				<vs-checkbox v-if="isActiveChatUser" v-model="selected"></vs-checkbox>
			</div>
		</div>
	</div>
</template>

<script>
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import firebase from "firebase/app";
// Import Store Module
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	name: "ResourceListItemSidebar",
	props: {
		resource: {type: Object, required: true},
		isActiveChatUser: {type: Boolean, default: true},
		componentParent: {type: String, default: "RESOURCE_CALENDAR"},
	},
	data() {
		return {
			database: firebase.database(),
			avatar: "",
			messages: [],
			total: 1,
			resource_local: JSON.parse(JSON.stringify(this.resource)),
		};
	},
	computed: {
		photoURL() {
			return this.avatar;
		},
		totalMessagesWithUnseen() {
			//this.$store.state.firebaseRealtime.messages.get(this.resource.id).length
			let data = this.$store.state.firebaseRealtime.firebaseTotalSeen[this.resource.id];
			return data !== undefined ? data : 0;
		},
		selected: {
			get() {
				return this.resource.selected;
			},
			set(val) {
				if (val) {
					switch (this.componentParent) {
						case "RESOURCE_CALENDAR":
							break;
						case "REASSIGN_EVENTS":
							this.$store.commit("moduleResource/SET_SELECTED_RESOURCE", this.resource);
							break;
						default:
							break;
					}
				}
			},
		},
		currentResourceId() {
			const currentResource = this.$store.getters["moduleSchedule/getCurrentResource"];
			if (currentResource.hasOwnProperty("id")) {
				return currentResource.id;
			} else {
				return 0;
			}
		},
	},
	methods: {
		getResourcePhoto() {
			const url = this.resource.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		getSelectedResources() {
			this.$store.dispatch("moduleSchedule/selectedResource", this.resource_local);
		},
	},
	watch: {},
	mounted() {
		this.getResourcePhoto();
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
	},
};
</script>
